<div class="container mx-auto p-8 bg-white rounded-lg shadow-lg space-y-6">
  <h1 class="text-2xl font-semibold">{{ editMode ? 'Editar Assinatura' : 'Nova Assinatura' }}</h1>

  <p-toast></p-toast>
  <p-confirmDialog></p-confirmDialog>

  <form [formGroup]="form" (ngSubmit)="salvar()" class="space-y-4">
    <div class="grid">
      <div class="col-6">
        <label for="empresaId" class="mb-1 font-medium text-gray-700">Empresa ID</label>
        <input id="empresaId" formControlName="empresaId" pInputText class="w-full p-2 border border-gray-300 rounded" />
      </div>

      <div class="col-6">
        <label for="nomeEmpresa" class="mb-1 font-medium text-gray-700">Nome Empresa</label>
        <input id="nomeEmpresa" formControlName="nomeEmpresa" pInputText class="w-full p-2 border border-gray-300 rounded" />
      </div>
    </div>

    <div class="grid">
      <div class="col-6">
        <label for="plano" class="mb-1 font-medium text-gray-700">Plano</label>
        <input id="plano" formControlName="plano" pInputText class="w-full p-2 border border-gray-300 rounded" />
      </div>

      <div class="col-6">
        <label for="dataInicio" class="mb-1 font-medium text-gray-700">Data Início</label>
        <input id="dataInicio" formControlName="dataInicio" pInputText type="date" class="w-full p-2 border border-gray-300 rounded" />
      </div>
    </div>

    <div class="flex space-x-4">
      <button pButton type="submit" class="btn btn-primary btn-md" [disabled]="form.invalid">
        <i class="pi pi-check mr-2"></i>
        <span>{{ editMode ? 'Salvar' : 'Cadastrar' }}</span>
      </button>

      <button pButton type="button" class="btn btn-secondary btn-md" (click)="cancelar()">
        <i class="pi pi-times mr-2"></i>
        <span>Cancelar</span>
      </button>
    </div>
  </form>
</div>
